import router from "../routes";
import axios from "./axios-auth";
import { eventBus } from "@/main";
export default {
  signUp({ commit, dispatch }, authData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/register" + langParam, {
          username: authData.userName,
          parent_email: authData.email,
          year_of_birth: authData.yearBirth,
          email: authData.childEmail,
          password: authData.password,
          returnSecureToken: true,
          subscription_type: authData.subscriptionType,
        })
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
          setTimeout(() => {
            dispatch("login", authData);
          }, 7000);
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  parentSignUp({ commit, dispatch }, authData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/parent_register" + langParam, {
          parent_username: authData.parentUsername,
          student_username: authData.studentUsername,
          first_name: authData.firstName,
          last_name: authData.lastName,
          country: authData.country.iso2
            ? authData.country.iso2
            : authData.country,
          parent_email: authData.email,
          parent_password: authData.parentPassword,
          student_password: authData.studentPassword,
          phone: authData.phone,
          returnSecureToken: true,
          subscription_type: "free",
          source: authData.source,
        })
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
          /*  setTimeout(() => {
                        router.push({ name: 'Login', query: { lang: lang } })
                    }, 7000) */
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  updateParentProfile({ commit, dispatch }, authData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/update-parent-profile" + langParam, {
          username: authData.userName,
          first_name: authData.firstName,
          last_name: authData.lastName,
          country: authData.country,
          parent_email: authData.email,
          password: authData.password,
          phone: authData.phone,
          returnSecureToken: true,
          subscription_type: authData.subscriptionType,
        })
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
          setTimeout(() => {
            router.push({ name: "Login", query: { lang: lang } });
          }, 2000);
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },

  login({ commit, state, dispatch }, authData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/login" + langParam, {
          username: authData.userNameOrEmailOrMobile || authData.userName,
          password: authData.password,
          type: authData.type,
        })
        .then((res) => {
          let studentProfile = res.data.data[0].student_profile || null;
          let parentProfile = res.data.data[0].parent_profile || null;
          let schoolProfile = res.data.data[0].schooladmin_profile || null;
          let teacherProfile = res.data.data[0].teacher_profile || null;
          // axios.interceptors.request.use(function (config) {
          //     const token = `Bearer ${res.data.data[0].api_token}`;
          //     config.headers.Authorization =  token;

          //     return config;
          // })
          let userObJ = {
            token: res.data.data[0].api_token,
            username: res.data.data[0].username,
            img_uri: res.data.data[0].img_uri,
            parentemail: res.data.data[0].parent_email,
            userId: res.data.data[0].id,
            hasVisitedIde: res.data.data[0].has_visited_ide,
            didWatchStory: res.data.data[0].did_watch_storyline_video,
            userType: res.data.data[0].user_type,
            isSchoolStudent: res.data.data[0].is_school_student,
            multiple_schools: res.data.data[0].multiple_schools,
          };

          localStorage.setItem("token", res.data.data[0].api_token);
          localStorage.setItem("username", res.data.data[0].username);
          localStorage.setItem("parentemail", res.data.data[0].parent_email);
          localStorage.setItem("userId", res.data.data[0].id);
          // localStorage.setItem('login-event', true);
          localStorage.setItem("login-event", "login" + Math.random());

          if (userObJ.userType == "teacher") {
            localStorage.setItem(
              "teacherName",
              res.data.data[0].first_name + " " + res.data.data[0].last_name
            );
          }

          if (userObJ.userType == "schooladmin") {
            localStorage.setItem("schoolName", res.data.data[0].school_name);
          }

          // localStorage.setItem('hasVisitedIde', res.data.data[0].has_visited_ide);
          // localStorage.setItem('didWatchStory', res.data.data[0].did_watch_storyline_video);
          if (userObJ.userType == "student" && studentProfile != null) {
            userObJ.userProfileId = studentProfile.id;
            userObJ.firstName = studentProfile.first_name;
            userObJ.schoolId = studentProfile.school_id;
            localStorage.setItem("userProfileId", studentProfile.id);
          } else if (userObJ.userType == "parent" && parentProfile != null) {
            userObJ.userProfileId = parentProfile.id;
            userObJ.firstName = parentProfile.first_name;
            userObJ.lastName = parentProfile.last_name;
            localStorage.setItem("userProfileId", parentProfile.id);
          } else if (
            userObJ.userType == "schooladmin" &&
            userObJ.multiple_schools == false
          ) {
            userObJ.userProfileId = schoolProfile.school_id;
            userObJ.firstName = schoolProfile.first_name;
            localStorage.setItem("userProfileId", schoolProfile.school_id);
          } else if (
            userObJ.userType == "schooladmin" &&
            userObJ.multiple_schools == true
          ) {
            userObJ.userProfileId = schoolProfile.school_id;
            userObJ.firstName = schoolProfile.first_name;
            localStorage.setItem("userProfileId", schoolProfile.school_id);
          } else {
            userObJ.userProfileId = teacherProfile.id;
            userObJ.schoolId = teacherProfile.school_id;
            userObJ.firstName = teacherProfile.first_name;
            localStorage.setItem("userProfileId", userObJ.userProfileId);
          }
          commit("authUser", userObJ);
          resolve(res);
          // if (userObJ.userType == 'student' && studentProfile.did_watch_storyline_video == 0) {
          //     router.push({name:'story',query:{lang:lang}})
          // }
          // if (userObJ.userType == 'student' && studentProfile.did_watch_storyline_video == 1) {
          if (userObJ.userType == "student") {
            router.push({ name: "Myworld", query: { lang: lang } });
          } else if (
            userObJ.userType == "schooladmin" &&
            userObJ.multiple_schools == false
          ) {
            console.log(
              userObJ.userType == "schooladmin" &&
                userObJ.multiple_schools == false
            );
            router.push({ name: "teachers", query: { lang: lang } });
          } else if (
            userObJ.userType == "schooladmin" &&
            userObJ.multiple_schools == true
          ) {
            console.log(
              userObJ.userType == "schooladmin" &&
                userObJ.multiple_schools == true
            );
            router.push({ name: "admin", query: { lang: lang } });
          } else if (userObJ.userType == "teacher") {
            router.push({ name: "classrooms", query: { lang: lang } });
          } else {
            router.push({ name: "manageMyKids", query: { lang: lang } });
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            console.log(error, "error");
            let messageObj = {
              text: error.response.data.data || error.username,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
            commit("setMessage", messageObj);
          }
          //console.log(error.config);
        });
    });
  },
  loginAsStudent({ commit, state, dispatch }, studentProfileId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/login-as-student" + langParam,
          {
            student_profile_id: studentProfileId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let studentProfile = res.data.data[0].student_profile || null;
          let userObJ = {
            token: res.data.data[0].api_token,
            username: res.data.data[0].username,
            parentemail: res.data.data[0].parent_email,
            userId: res.data.data[0].id,
            hasVisitedIde: res.data.data[0].has_visited_ide,
            didWatchStory: res.data.data[0].did_watch_storyline_video,
            userType: res.data.data[0].user_type,
            parentProfileId: res.data.data[0].parent_profile_id,
            isSchoolStudent: res.data.data[0].is_school_student,
          };
          localStorage.setItem("token", res.data.data[0].api_token);
          localStorage.setItem("username", res.data.data[0].username);
          localStorage.setItem("parentemail", res.data.data[0].parent_email);
          localStorage.setItem("userId", res.data.data[0].id);
          localStorage.setItem(
            "hasVisitedIde",
            res.data.data[0].has_visited_ide
          );
          localStorage.setItem(
            "didWatchStory",
            res.data.data[0].did_watch_storyline_video
          );
          localStorage.setItem("login-event", "login" + Math.random());
          if (userObJ.userType == "student" && studentProfile != null) {
            userObJ.userProfileId = studentProfile.id;
            localStorage.setItem("userProfileId", studentProfile.id);
            userObJ.schoolId = studentProfile.school_id;
          }
          commit("authUser", userObJ);
          resolve(true);
          // if (userObJ.userType == 'student' && studentProfile.did_watch_storyline_video == 0) {
          //     router.replace('/story');
          // }
          // if (userObJ.userType == 'student' && studentProfile.did_watch_storyline_video == 1) {
          if (userObJ.userType == "student") {
            router.push({ name: "Myworld", query: { lang: lang } });
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            console.log(error, "error");
            let messageObj = {
              text: error.response.data.data || error.username,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
            commit("setMessage", messageObj);
          }
          //console.log(error.config);
        });
    });
  },
  loginBackAsParent({ commit, state, dispatch }, parentProfileId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/login-back-as-parent" + langParam,
          {
            parent_profile_id: parentProfileId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let parentProfile = res.data.data[0].parent_profile || null;
          let userObJ = {
            token: res.data.data[0].api_token,
            username: res.data.data[0].username,
            parentemail: res.data.data[0].parent_email,
            userId: res.data.data[0].id,
            hasVisitedIde: res.data.data[0].has_visited_ide,
            didWatchStory: res.data.data[0].did_watch_storyline_video,
            userType: res.data.data[0].user_type,
          };
          localStorage.setItem("token", res.data.data[0].api_token);
          localStorage.setItem("username", res.data.data[0].username);
          localStorage.setItem("parentemail", res.data.data[0].parent_email);
          localStorage.setItem("userId", res.data.data[0].id);

          // localStorage.setItem('hasVisitedIde', res.data.data[0].has_visited_ide);
          // localStorage.setItem('didWatchStory', res.data.data[0].did_watch_storyline_video);

          if (userObJ.userType == "parent" && parentProfile != null) {
            userObJ.userProfileId = parentProfile.id;
            localStorage.setItem("userProfileId", parentProfile.id);
          }

          commit("authUser", userObJ);
          resolve(true);

          if (userObJ.userType == "parent") {
            router.push({ name: "manageMyKids", query: { lang: lang } });
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            console.log(error, "error");
            let messageObj = {
              text: error.response.data.data || error.username,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
            commit("setMessage", messageObj);
          }
          //console.log(error.config);
        });
    });
  },
  clearMessages({ commit }) {
    commit("clearMess");
  },
  logout({ commit, dispatch, state }, goToLogin = true) {
    let lang = router.currentRoute.query.lang;
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/logout",
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
          commit("clearAuthData");
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("parentemail");
          localStorage.removeItem("userId");
          localStorage.removeItem("userProfileId");
          // localStorage.removeItem('hasVisitedIde');
          // localStorage.removeItem('didWatchStory');
          localStorage.removeItem("userType");
          localStorage.removeItem("parentProfileId");
          localStorage.setItem("logout-event", "logout" + Math.random());
          if (goToLogin) {
            router.push({ name: "Login", query: { lang: lang } });
          }
        })
        .catch((error) => {
          commit("clearAuthData");
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("parentemail");
          localStorage.removeItem("userId");
          localStorage.removeItem("userProfileId");
          // localStorage.removeItem('hasVisitedIde');
          // localStorage.removeItem('didWatchStory');
          localStorage.removeItem("userType");
          localStorage.removeItem("parentProfileId");
          if (goToLogin) {
            router.push({ name: "Login", query: { lang: lang } });
          }
          reject(error);
        });
    });
  },
  contactUs({ commit, dispatch }, formData) {
    axios
      .post("/contact", {
        name: formData.name,
        message: formData.message,
        email: formData.email,
        username: formData.username,
        phone_number: formData.phone,
        country: formData.country,
        reason: formData.reason,
        returnSecureToken: true,
      })
      .then((res) => {
        let messageObj = {
          text: res.data.data.message,
          className: "alert-success",
          isActive: true,
        };
        commit("setMessage", messageObj);
      })
      .catch((error) => {
        // Error
        if (error.response) {
          // console.log(error.response.data.username);
          let messageObj = {
            text: error.response.data.username,
            className: "alert-danger",
            isActive: false,
          };
          commit("setMessage", messageObj);
        }
        console.log(error.config);
      });
  },
  fetchStudentWheelStatus({ commit, state, dispatch }, lessonId) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-student-course-projects-stats/" + lessonId, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  fetchCourseDetails({ commit, state, dispatch }, courseNumber) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/coursedetails/" + courseNumber + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          commit("setCourseDetails", data);
          commit("setCourseId", data.course.id);
          commit("setIsTrial", data.is_trail);
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  fetchLessonprevideo({ commit, state, dispatch }, courseObj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/lessonprevideo/" +
            courseObj.lessonId +
            "/" +
            courseObj.courseId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let lessonPreVideo = res.data.data;
          resolve(lessonPreVideo);
          commit("setLessonPreVideo", lessonPreVideo);
        })
        .catch((error) => {
          // dispatch('isAuth', error);
          reject(error);
        });
    });
  },
  fetchQuestions({ state, dispatch }, courseId) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/ide-questions/" + courseId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error.response.data.data);
        });
    });
  },
  fetchIde({ commit, state, dispatch }, lessonId) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/ide/" + lessonId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let ideInfo = res.data;
          commit("setIdeInfo", ideInfo.data);
          commit("setIdeVisited", res.data.has_visited_ide);
          commit("hasIdeVisited", res.data.has_visited_ide);
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  studentQuestionsSubmission({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/student-questions-submission",
          {
            answers: formData.answers,
            question_points: formData.points,
            gm_task_id: 3,
            course_id: formData.courseId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error.response.data.data);
          dispatch("isAuth", error);
        });
    });
  },
  studentGamesSubmission({ commit, state, dispatch }, formdata) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/submit-game-lesson",
          {
            lesson_id: formdata.lessonId,
            course_id: formdata.courseId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          dispatch("isAuth", error);
        });
    });
  },
  isVerifyUser({ commit, state, dispatch }, urlData) {
    let isVerifyUserUrl = "/parent/verify/";
    return new Promise((resolve, reject) => {
      axios
        .get(isVerifyUserUrl + urlData.token)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          // Error
          reject(error);
          if (localStorage.getItem("token") === null) {
            router.push({ name: "Login" });
          } else {
            router.push({ name: "manageMyKids" });
          }
        });
    });
  },
  forgetPassword({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/password/email" + langParam, {
          username: formData.userNameOrEmailOrMobile,
          type: formData.type,
          "g-recaptcha-response": formData.response,
        })
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
            // commit('setMessage', messageObj);
          }
        })
        .catch((error) => {
          dispatch("isAuth", error);
          // Error
          let messageObj = {
            text: error.response.data.data.message,
            code: error.response.data.data.code,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
          // commit('setMessage', messageObj);
        });
    });
  },
  resetGuestPassword({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/password/reset" + langParam, {
          password: formData.password,
          token: formData.token,
          password_confirmation: formData.password_confirmation,
        })
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
          }
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            let messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  setIsFirstTime({ state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    // if (state.hasVisitedIde) {
    //     state.isTutorialActive = false;
    //     return;
    // }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/user-ide-visit",
          {
            user_id: obj.userId,
            has_visited_ide: obj.isVisited,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getImageCategories({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-image-categories" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let imgCateg = res.data.data;
          commit("setImageCateg", imgCateg.image_categories);
          resolve(imgCateg);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getImagesByCategId({ commit, state, dispatch }, imagesObj) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-images-by-category/" +
            imagesObj.currentCateg.id +
            "?size=" +
            imagesObj.size +
            "&page=" +
            imagesObj.pageNumber,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          commit("setImagesByCategId", data.images);
          resolve(data.images);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSoundCategories({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-sound-categories" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let soundCateg = res.data.data;
          commit("setSoundCateg", soundCateg.sound_categories);
          resolve(soundCateg);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSoundByCategId({ commit, state, dispatch }, soundsObj) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-sounds-by-category/" +
            soundsObj.currentCateg.id +
            "?size=" +
            soundsObj.size +
            "&page=" +
            soundsObj.pageNumber +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          commit("setSoundByCategId", data.sounds);
          resolve(data.sounds);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  studentProjectSubmission({ commit, state, dispatch }, projectObj) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/student-project-submission",
          {
            project_name: projectObj.projectName,
            student_profile_id: projectObj.studentProfileId,
            python_code: projectObj.python_code,
            code: projectObj.code,
            js_code: projectObj.js_code,
            html_code: projectObj.html_code,
            css_code: projectObj.css_code,
            thumb_uri: projectObj.thumb_uri,
            img_uri: projectObj.img_uri,
            project_id: projectObj.projectId,
            is_course_project: projectObj.isSavedProject,
            is_confirmed_submission: projectObj.isConfirmSubmit,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          reject(error.response.data.data);
          dispatch("isAuth", error);
        });
    });
  },
  calculateTaskPoints({ commit, state, dispatch }, lessonId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/calculate-task-points/1",
          {
            lesson_id: lessonId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  calculateHintsPoints({ commit, state, dispatch }, lessonId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/calculate-hints-points/" + 11,
          {
            lesson_id: lessonId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  courseProjectSubmission({ commit, state, dispatch }, projectObj) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/course-project-submission",
          {
            project_name: projectObj.projectName,
            student_profile_id: projectObj.studentProfileId,
            code: projectObj.code,
            python_code: projectObj.python_code,
            js_code: projectObj.js_code,
            html_code: projectObj.html_code,
            css_code: projectObj.css_code,
            thumb_uri: projectObj.thumb_uri,
            img_uri: projectObj.img_uri,
            lesson_project_template_id: projectObj.lesson_project_template_id,
            lesson_id: projectObj.lesson_id,
            course_id: projectObj.coursedId,
            gm_task_id: 4,
            is_graduation_project: projectObj.is_graduation_project,
            project_id: projectObj.projectId,
            is_confirmed_submission: projectObj.isConfirmSubmit,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
          // alert(res.data.data.message)
        })
        .catch((error) => {
          reject(error);
          dispatch("isAuth", error);
        });
    });
  },
  getSchoolSearchFilter({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/get-school-search-filters/" + state.schoolId, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentIndividualProject({ commit, state, dispatch }, studentProfileId) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-student-individual-project/" + studentProfileId, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data.projects);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getGraduationProject({ commit, state, dispatch }, lessonId) {
    if (!state.token) {
      return;
    }
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-graduation-project/" + lessonId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          // commit('setGraduationProject', res.data.data.project);
          commit("setGraduationProjectPlayground", res.data.data.project);
          commit("isGoalVisited", false);
          resolve(res.data.data.project);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentCourseProject({ commit, state, dispatch }, studentProfileId) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-student-course-project/" + studentProfileId, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          commit("setStudentCourseProject", data.projects);
          resolve(data.projects);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentProfile({ commit, state, dispatch }, student_profile_id) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-student-profile?student_profile_id=" +
            student_profile_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentProfileByCourseId({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-student-profile-by-courseid?student_profile_id=" +
            obj.student_profile_id +
            "&course_id=" +
            obj.id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getRandomCourseProject({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/get-random-course-project/" +
            obj.lessonId +
            "/" +
            obj.type +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          commit("setRandomCourseProject", data.project);
          resolve(data.project);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error.response);
        });
    });
  },
  getStudentOverview({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/studentoverview/", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentsTopTen({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/students-top-ten/", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentSubmissionsCount({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-student-submissions-count", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  isStudentJunior({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/is-student-junior", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
          // console.log(res.data.data.is_junior_student)
          commit("setStudentType", res.data.data.is_junior_student);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentProfileForStudent({ commit, state, dispatch }, student_profile_id) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/studentprofile?student_profile_id=" + student_profile_id, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getClassroomList({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/get-classroom-list", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentProfileForStudentById({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/get-studentprofile-by-courseid?student_profile_id=" +
            obj.student_profile_id +
            "&course_id=" +
            obj.id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  storylineVideoStatus({ commit, state, dispatch }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/storyline-video-status",
          {
            user_id: userId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  //PARENT
  getPrograms({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-programs/", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  createNewChild({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/create-new-child",
          {
            //    last_name:formData.last_name,
            //    first_name:formData.first_name,
            name: formData.name,
            username: formData.username,
            // email: formData.parentEmail,
            // parent_email: formData.parentEmail,
            year_of_birth: formData.year,
            password: formData.password,
            // confirm_password: formData.confirmPassword,
            // subscription_type_id: 1,
            // subscription_plan_id: 2
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            // text: error.response.data.data.errors,
            text: error.response.data.errors,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },

  linkNewChild({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/link-parent-child" + langParam,
          {
            username: formData.username,
            password: formData.password,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            // text: error.response.data.data.errors,
            text: error.response.data.data.message,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },

  getParentChildrenInfo({ commit, state }, pageNumber) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-parent-children-info", {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            Child_number: 2,
            page_number: pageNumber,
          },
        })

        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  enableChild({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/enable-child",
          {
            student_profile_id: id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            text: error.response.data.data.errors,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },
  disableChild({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/disable-child",
          {
            student_profile_id: id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  /* getCountry({ commit, state, dispatch }) {
        let lang = router.currentRoute.query.lang;
        let langParam = '';
        if (lang) {
            langParam = '?lang=' + lang;
        }
        return new Promise((resolve, reject) => {
            axios.get('/get-countries'+langParam, {
                headers: { 'Authorization': 'Bearer ' + state.token }
            })
                .then(res => {
                    resolve(res.data.data);
                })
                .catch(error => {
                    // dispatch('isAuth',error);
                    reject(error)
                })
        })
    },*/
  getPlans({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-parent-plans", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          // dispatch('isAuth',error);
          reject(error);
        });
    });
  },
  getPlansHome({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-plans" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getParentSubscriptionStatus({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-parent-subscription-status", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            text: error.response.data.data.errors,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },
  getAvailableChildren({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-available-children/", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  placePayment({ commit, state, dispatch }, paymentInfo) {
    return new Promise((resolve, reject) => {
      axios
        .post("/place-payment", paymentInfo, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  renewParentSubscription({ commit, state, dispatch }, paymentInfo) {
    return new Promise((resolve, reject) => {
      axios
        .post("/renew-parent-subscription", paymentInfo, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  resetPassword({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/reset-student-password",
          {
            student_profile_id: formData.studentProfileId,
            password: formData.pass,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            text: error.response.data.data.errors,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },
  cancelParentsubscription({ commit, state, dispatch }, studentArry) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/cancel-parent-subscription",
          {
            student_ids: studentArry,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            text: error.response.data.data.errors,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },
  getMerchantInfo({ commit, state, dispatch }, urlAndDevicePrintObj) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/get-merchant-info",
          {
            return_url: urlAndDevicePrintObj.returnUrl,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  setSubscriptionPlan({ commit, state }, planObj) {
    commit("setSubscriptionPlan", planObj);
  },
  //SCHOOL
  schoolSignUp({ commit, dispatch }, authData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/school/schooladmin-register" + langParam, {
          name: authData.schoolName,
          abbreviation: authData.abbreviation,
          website: authData.website,
          phone_number: authData.phoneNumber,
          parent_email: authData.emailInfo,
          address: authData.fullAdress,
          country: authData.country,
          city: authData.city,
          email: authData.emailAdmin,
          username: authData.userName,
          first_name: authData.firstName,
          last_name: authData.lastName,
          password: authData.password,
          schooladmin_phone_number: authData.phoneAdmin,
          subscription_type: "free",
        })
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
          setTimeout(() => {
            router.push({ path: "/login", query: { lang: lang } });
          }, 70000);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          console.log(error);
          if (error.response) {
            messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  addSchoolTeacher({ commit, state, dispatch }, authData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/school/add-school-teacher" + langParam,
          {
            first_name: authData.firstName,
            last_name: authData.lastName,
            parent_email: authData.email,
            teacher_phone_number: authData.phone,
            password: authData.password,
            username: authData.username,
            school_id: authData.schoolId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            if (error.response.data.data.errors) {
              messageObj = {
                text: error.response.data.data.errors,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data.data.message,
                className: "alert-danger",
                isActive: false,
              };
            }

            reject(messageObj);
          }
        });
    });
  },
  getSchoolTeacherInfo(
    { commit, state, dispatch },
    { schoolId, pageNumber, teachersList }
  ) {
    let page = "?page=" + pageNumber;
    if (pageNumber == 0) {
      page = " ";
    } else {
      page = "?page=" + pageNumber;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/school/get-school-teacher-info" + "/" + schoolId + page, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolStudentCourse({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .get("/school/get-school-student-course", {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            teacher_id: formData.teacherId,
            course_id: formData.courseId,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolStudentsData({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/school/get-students-by-teacher/", +obj.teacherId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolStudentsDetails({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/school/get-school-students-details" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            student_id: formData.profileId,
            course_id: formData.courseId,
          },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getTeacherStudentsDetails({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/get-school-students-details" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            student_id: formData.profileId,
            course_id: formData.courseId,
          },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  resetSchoolTeacherPassword({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/school/reset-school-teacher-password",
          {
            password: formData.pass,
            teacher_profile_id: formData.teacherId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
            commit("setMessage", messageObj);
          }
        })
        .catch((error) => {
          dispatch("isAuth", error);
          // Error
          //console.log(error)
          reject(error);
        });
    });
  },
  disableSchoolTeacherAccount({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/school/disable-school-teacher-account",
          {
            teacher_profile_id: id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: false,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  enableSchoolTeacherAccount({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/school/enable-school-teacher-account",
          {
            teacher_profile_id: id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: false,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolClassroomDetails(
    { commit, state, dispatch },
    { classRoomId, pageNumber }
  ) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-school-classroom-details/" + classRoomId + langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            params: {
              student_number: 10,
              page_number: pageNumber,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolClassroomLockedStatus({ commit, state, dispatch }, classRoomId) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-school-teacher-classroom-locked-status/" +
            classRoomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data[0]);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolClassroomLessons({ commit, state, dispatch }, classRoomId) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-school-teacher-classroom-lessons/" +
            classRoomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data[0]);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolClassroomLessonsReset({ commit, state, dispatch }, classRoomId) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-classroom-completed-lessons" +
            "?classroom_id=" +
            classRoomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data.lessons);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolTeacherClassroomsSummary(
    { commit, state, dispatch },
    { schoolId, pageNumber }
  ) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-school-teacher-classrooms-summary/" +
            schoolId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            params: {
              classroom_number: 6,
              page_number: pageNumber,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getSchoolStudentComments({ commit, state, dispatch }, obj) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-school-student-comments/" +
            obj.submission_id +
            "?submission_type_id=" +
            obj.submission_type,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  // addCommentOnStudentSubmission({ commit, state,dispatch }, formData) {
  //     return new Promise((resolve, reject) => {
  //         axios.post('/teacher/add-comment-on-student-submission' + '?api_token=' + state.token, {
  //             teacher_profile_id: formData.teacher_profile_id,
  //             student_profile_id: formData.student_profile_id,
  //             submission_type_id: formData.submission_type_id,
  //             submission_id: formData.submission_id,
  //             comments: formData.comments
  //         })
  //             .then(res => {
  //                 let messageObj = {
  //                     text: res.data.data.message,
  //                     className: 'alert-success',
  //                     isActive: false
  //                 };
  //                 resolve(messageObj);
  //             })
  //             .catch(error => {
  //                 dispatch('isAuth',error);
  //                 reject(error)
  //             })
  //     })
  // },
  approveStudentSubmission({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/teacher/approve-student-submission",
          {
            submission_type_id: formData.submissionTypeId,
            submission_id: formData.submissionId,
            comment: formData.comment,
            task_id: formData.taskId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: false,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            let messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  disapproveStudentSubmission({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/teacher/disapprove-student-submission",
          {
            submission_type_id: formData.submissionTypeId,
            submission_id: formData.submissionId,
            comment: formData.comment,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: false,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolstudentSubmissionsDetails({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-school-student-submission-details/" +
            data.submission_id +
            "?submission_type_id=" +
            data.submission_type_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentSharedCodeDetails({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/guest-shared-code/" +
            data.submission_id +
            "?submission_type_id=" +
            data.submission_type_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentCourseProjectById({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/get-student-course-project-by-id" +
            "?submission_id=" +
            data.submission_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentIndividualProjectById({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/get-student-individual-project-by-id" +
            "?submission_id=" +
            data.submission_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolstudentQuestions(
    { commit, state, dispatch },
    { student_id, lesson_id }
  ) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-school-student-lesson-assessment-details/" +
            student_id +
            "?lesson_id=" +
            lesson_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getLessonQuestionSolution({ commit, state, dispatch }, { lessonId }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-course-lesson-question-solution/" +
            lessonId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentAssementResult({ commit, state, dispatch }, { lesson_id }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get("/assessmentresult" + "?lesson_id=" + lesson_id + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  GetSchoolSetupInformation({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-school-setup-information/" + state.schoolId + langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let allowLessonLocking =
            res.data.data.school_info.allow_teacher_lesson_locking;
          let allowfinishLessons =
            res.data.data.school_info.allow_teacher_finish_lessons;

          resolve(res);
          commit("setAllowLessonLocking", allowLessonLocking);
          commit("setAllowFinishLessons", allowfinishLessons);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  addSchoolClassroom({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      let messageObj = {};
      axios
        .post(
          "/teacher/add-school-classroom" + langParam,
          {
            name: formData.name,
            number_of_seats: formData.number_of_seats,
            school_grade_id: formData.classroom_grade_id,
            course_id: formData.courses,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          // console.log(error.response.data)
          if (error.response) {
            messageObj = {
              text: error.response.data.errors.name[0],
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  updateSchoolClassroomSchedul({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/teacher/update-school-classroom-schedule" + langParam,
          {
            classroom_id: formData.classRoomId,
            classroom_schedules: formData.days,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  addSchoolStudentToClassroom({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let messageObj = {};
      axios
        .post(
          "/teacher/add-school-student-to-classroom",
          {
            username: formData.username,
            password: formData.password,
            first_name: formData.first_name,
            last_name: formData.last_name,
            password_confirmation: formData.password_confirmation,
            school_id: formData.school_id,
            classroom_id: formData.classroom_id,
            year_of_birth: formData.year_of_birth,
            teacher_id: state.userProfileId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            if (error.response.data.data.errors) {
              messageObj = {
                text: error.response.data.data.errors,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data.data.message,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },
  updateLessonsStatus({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      let messageObj = {};
      axios
        .post(
          "/teacher/update-classroom-locked-status" + langParam,
          {
            locked_status: formData.lockedStatus,
            classroom_id: formData.classRoomId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  finishLesson({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      let messageObj = {};
      axios
        .get(
          `/finish-lesson/${formData.classRoomId}/${formData.lessonId}` +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  resetQuestionByLesson({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      let messageObj = {};
      axios
        .post(
          "/teacher/delete-student-question-submissions-by-lesson" + langParam,
          {
            lessons_ids: formData.lessonsId,
            student_ids: formData.student_ids,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  finishStudentLessonByTeacher({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      let messageObj = {};
      axios
        .post(
          "/teacher/finish-student-lesson-by-teacher" + langParam,
          {
            lessons_ids: formData.lessonsId,
            classroom_id: formData.classRoomId,
            studentIds: formData.students,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  addStudentToClassroom({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      let messageObj = {};
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/teacher/assign-school-student-to-classroom" + langParam,
          {
            classroom_id: formData.classRoomId,
            students_ids: formData.students_ids,
            school_id: formData.school_id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  assignStudentToClassroom({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-unassigned-students/" +
            formData.school_id +
            "?classroom_id=" +
            formData.classroom_id,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  generateLoginName({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/generate-student-username", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  resetLessonsForStudents({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let messageObj = {};
      axios
        .post(
          "/teacher/reset-lessons-for-students-classroom",
          {
            student_id: formData.student_id,
            lessons_ids: formData.lessons_ids,
            classroom_id: formData.classroom_id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  removeSchoolStudentFromClassroom({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      let messageObj = {};
      axios
        .post(
          "/teacher/remove-student-from-school-classroom" + langParam,
          {
            students_ids: formData.students_ids,
            classroom_id: formData.classroom_id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  getStudentNotifications({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-student-notifications", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  changeIsNotificationSeenFlagToTrue({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/change-is-notification-seen-flag-to-true/" + id,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function(error) {
          console.log(error);
        });
    });
  },
  resetSchoolStudentPassword({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/teacher/reset-school-student-password" + langParam,
          {
            password: formData.password,
            student_profile_id: formData.studentProfileId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
          }
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  changeHasSeenModalFlagToTrue({ commit, state, dispatch }, courseId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/change-has-seen-modal-flag-to-true/" + courseId,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  generateStudentCertificate({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/generate-student-certificate/" +
            formData.courseId +
            "?first_name=" +
            formData.first_name +
            "&last_name=" +
            formData.last_name,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  changeLanguage({ commit, state, dispatch }, lang) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/change-language?lang=" + lang,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function(error) {
          console.log(error);
        });
    });
  },
  isAuth({ dispatch }, error) {
    let langParam = "";
    let lang = router.currentRoute.query.lang;
    if (lang) {
      langParam = "?lang=" + lang;
    }
    switch (error.response.status) {
      case 401:
        alert("You are not authorized");
        dispatch("logout");
        return;
      case 429:
        dispatch("logout");
        return;
      case 403:
        router.push({ name: "PageNotFound", query: { lang: lang } });
        return;
      case 404:
        router.push({ name: "PageNotFound", query: { lang: lang } });
        return;
    }
  },
  getStudentCourseSubmissions({ commit, state, dispatch }, obj) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/get-student-course-submissions?approval_status_id=" +
            obj.approval_status_id +
            "&course_id=" +
            obj.course_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            params: {
              records_per_page: 10,
              page_number: obj.pageNumber,
            },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentProjectSubmissions({ commit, state, dispatch }, obj) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-student-project-submissions?approval_status_id=" +
            obj.approval_status_id +
            "&type=" +
            obj.projectType,
          {
            headers: { Authorization: "Bearer " + state.token },
            params: {
              records_per_page: 10,
              page_number: obj.pageNumber,
            },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getCourseLessonsVideos({ commit, state, dispatch }, courseId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-course-lesson-videos" +
            "?course_id=" +
            courseId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data.lesson_videos);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getCourseLessonsSolutions({ commit, state, dispatch }, obj) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-course-lesson-code-solution" +
            "?course_id=" +
            obj.courseId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data.challenges_solutions);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getCourseChallengesSolutions({ commit, state, dispatch }, obj) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-course-challenge-code-solution" +
            "?course_id=" +
            obj.courseId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            params: {
              records_per_page: 10,
              page_number: obj.pageNumber,
            },
          }
        )
        .then((res) => {
          resolve(res.data.data);
          // Assuming the response structure is res.data.data.challenges_solutions.id
          const challengeIds = res.data.data.challenges_solutions.map(
            (solution) => solution
          );
          commit("setChallenges", challengeIds);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getSchoolTeacherClassroomAssessments({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-teacher-classroom-assessments/" +
            obj.teacherId +
            "?classroom_id=" +
            obj.classroomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getSchoolTeacherClassroomlessonSubmissions({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-teacher-classroom-lesson-submissions/" +
            obj.teacherId +
            "?classroom_id=" +
            obj.classroomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolTeacherClassroomCourseSubmissions({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-teacher-classroom-course-submissions/" +
            obj.teacherId +
            "?classroom_id=" +
            obj.classroomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolTeacherClassroomStudentSubmissions(
    { commit, state, dispatch },
    obj
  ) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-teacher-classroom-student-submissions/" +
            obj.teacherId +
            "?classroom_id=" +
            obj.classroomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  createPaypal({ commit, state, dispatch }, urlAndDevicePrintObj) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/checkout-paypal",
          {
            return_url: urlAndDevicePrintObj.returnUrl,
            amount: urlAndDevicePrintObj.amount,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  /*   createPaypalCompetetion({ commit, state, dispatch }, urlAndDevicePrintObj) {
        return new Promise((resolve, reject) => {
            axios.post('/checkout-paypal-competition', {
                return_url: urlAndDevicePrintObj.returnUrl,
                amount:urlAndDevicePrintObj.amount
            }, {
                    headers: { 'Authorization': 'Bearer ' + state.token }
                })
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    dispatch('isAuth', error);
                    reject(error)
                })
        })
    },*/
  executePaypal({ commit, state, dispatch }, paymentObj) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/execute-paypal",
          {
            payer_id: paymentObj.payerId,
            payment_id: paymentObj.paymentId,
            subscription_plan_id: paymentObj.subscription_plan_id,
            student_ids: paymentObj.student_ids,
            with_assisted_learning: paymentObj.with_assisted_learning,
            coupon_code: paymentObj.coupon_code,
            course_id: paymentObj.course_id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  /* executePaypalCompetetion({ commit, state, dispatch }, paymentObj) {
        let lang = router.currentRoute.query.lang;
        let langParam = '';
        if (lang) {
            langParam = '?lang=' + lang;
        }
        return new Promise((resolve, reject) => {
            axios.post('/execute-paypal-competition'+langParam,  {
                payer_id: paymentObj.payerId,
                payment_id: paymentObj.paymentId,
                register_for_competetion:paymentObj.register_for_competetion,
                competition_plan_id:paymentObj.competition_plan_id,
                user_info:paymentObj.studentInformation
            }, {
                    headers: { 'Authorization': 'Bearer ' + state.token }
                })
                .then(res => {
                    resolve(res)
                })
                .catch(error => {
                    dispatch('isAuth', error);
                    reject(error)
                })
        })
    },*/
  getSchoolAdminTeacherClassDetails({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .get("/school/get-school-students-classroom-details", {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            classroom_id: formData.classId,
            teacher_id: formData.teacherId,
          },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentSchoolCourses({ commit, state, dispatch }, studentId) {
    return new Promise((resolve, reject) => {
      axios
        .get("/school/get-school-student-courses", {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            student_profile_id: studentId,
          },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  /*   getCompetitionPlans({ commit, state, dispatch }) {
        let lang = router.currentRoute.query.lang;
        let langParam = '';
        if (lang) {
            langParam = '?lang=' + lang;
        }
        return new Promise((resolve, reject) => {
            axios.get('/get-competition-plans'+langParam, {
                headers: { 'Authorization': 'Bearer ' + state.token }
            })
                .then(res => {
                    resolve(res);
                })
                .catch(error => {
                    // dispatch('isAuth',error);
                    reject(error)
   
                   })
        })
    },
  /*  checkCompetitionInfo({ commit, state, dispatch }, obj) {
        return new Promise((resolve, reject) => {
            axios.post('/check-competition-info',  {
                username: obj.username,
                password: obj.password,
                first_name: obj.first_name,
                last_name: obj.last_name,
                email:obj.email,
                phone_number:obj.phone,
                country:obj.country
            }, {
                    headers: { 'Authorization': 'Bearer ' + state.token }
                })
                .then(res => {
                    resolve(res)
                })
                .catch(error => {
                    dispatch('isAuth', error);
                        // Error
                        let messageObj
                        if (error.response) {
                            if (error.response.data.data.errors) {
                                messageObj = {
                                    text: error.response.data.data.errors,
                                    className: 'alert-danger',
                                    isActive: false
                                };
                            } else {
                                messageObj = {
                                    text: error.response.data.data.message,
                                    className: 'alert-danger',
                                    isActive: false
                                };
                            }
                            reject(messageObj)
    
                        }
                    })
                })
            },    
            
        
             
            placePaymentCompetition({ commit, state, dispatch }, paymentInfo) {
                
                return new Promise((resolve, reject) => {
                    axios.post('/place-payment-competition', paymentInfo, {
                        headers: { 'Authorization': 'Bearer ' + state.token }
                    })
                        .then(res => {
                            resolve(res);
                        })
                        .catch(error => {
                            dispatch('isAuth', error);
                            reject(error);
                        })
                })
            },
          
            registerPaymentCompetition({ commit, state, dispatch }, paymentInfo) {
                let lang = router.currentRoute.query.lang;
                let langParam = '';
                if (lang) {
                    langParam = '?lang=' + lang;
                }
                return new Promise((resolve, reject) => {
                    axios.post('/register-payment-competition'+langParam, paymentInfo, {
                        headers: { 'Authorization': 'Bearer ' + state.token }
                    })
                        .then(res => {
                            resolve(res);
                        })
                        .catch(error => {
                            dispatch('isAuth', error);
                            reject(error);
                        })
                })
            },*/
  editParentProfile({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post("/edit-parent-profile" + langParam, formData, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let messageObj = {
            text: res.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj;
          if (error.response) {
            if (error.response.data) {
              messageObj = {
                text: error.response.data,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },

  // editParentProfile({ commit, state, dispatch }, formData) {
  //     return new Promise((resolve, reject) => {
  //         axios.post('/edit-parent-profile', formData, {
  //             headers: { 'Authorization': 'Bearer ' + state.token }
  //         }).then(response => {
  //             resolve(response.data);
  //         }).catch(error => {
  //             dispatch('isAuth', error);
  //             reject(error);
  //         })
  //     })
  // },
  getParentProfile({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-parent-profile" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data[0]);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  parentResetPassword({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/reset-parent-password", data, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          // dispatch('isAuth', error);
          dispatch("isAuth", error);
          if (error.response.data) {
            resolve(error.response.data);
          }
        });
    });
  },
  uploadImageProfile({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/upload-image-profile", data, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          // dispatch('isAuth', error);
          reject(error);
        });
    });
  },

  getParentCouponsDiscount({ commit, state, dispatch }, data) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-parent-coupons-discount/" +
            data.code +
            "/" +
            data.planId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          // dispatch('isAuth', error);
          reject(error.response.data.data);
        });
    });
  },

  newsletter({ commit, state, dispatch }, obj) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/newsletter" + langParam,
          {
            email: obj.email,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          // Error
          let messageObj;
          if (error.response) {
            if (error.response.data.data.errors) {
              messageObj = {
                text: error.response.data.data.errors,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data.data.message,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },
  teacherProjectSubmission({ commit, state, dispatch }, projectObj) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/teacher/teacher-project-submission",
          {
            project_name: projectObj.projectName,
            teacher_profile_id: projectObj.teacherProfileId,
            code: projectObj.code,
            js_code: projectObj.js_code,
            html_code: projectObj.html_code,
            python_code: projectObj.python_code,
            css_code: projectObj.css_code,
            thumb_uri: projectObj.thumb_uri,
            img_uri: projectObj.img_uri,
            project_id: projectObj.projectId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          reject(error.response.data.data);
          dispatch("isAuth", error);
        });
    });
  },
  getTeacherIndividualProject({ commit, state, dispatch }, teacherProfileId) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/get-teacher-individual-project/" + teacherProfileId, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data.projects);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getCliantInfo({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("https://ipapi.co/json/")
        .then((res) => {
          commit("setCliantInfo", res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCurriculumOverview({ commit, state, dispatch }, program_name) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-curriculum-overview?program_name=" + program_name + langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  editSchoolTeacherAccount({ commit, state, dispatch }, authData) {
    let messageObj = {};
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/school/edit-school-teacher-account",
          {
            first_name: authData.firstName,
            last_name: authData.lastName,
            username: authData.username,
            teacher_id: authData.teacherId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            if (error.response.data.data.errors) {
              messageObj = {
                text: error.response.data.data.errors,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data.data.message,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },
  // Edit student info [username, firstname, lastname]
  editStudentInfo({ commit, state, dispatch }, authData) {
    let messageObj = {};
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/edit-student-info",
          {
            first_name: authData.firstName,
            last_name: authData.lastName,
            user_name: authData.username,
            studentId: authData.studentId,
            year_of_birth: authData.year,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          // Error
          if (error.response) {
            if (error.response.data.data.errors) {
              messageObj = {
                text: error.response.data.data.errors,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data.data.message,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },
  removeClassroom({ commit, state, dispatch }, id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/teacher/remove-school-classroom" + langParam,
          {
            classroom_id: id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  updateSchoolClassroom({ commit, state, dispatch }, classroomData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/teacher/edit-school-classroom" + langParam,
          {
            classroom_id: classroomData.classroom_id,
            classroom_name: classroomData.classroom_name,
            school_grade_id: classroomData.school_grade_id,
            course_id: classroomData.course_id,
            // number_of_seats: classroomData.number_of_seats,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  resetStudentChallenges({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      let messageObj = {};
      axios
        .post(
          "/teacher/reset-student-challange-submissions-by-lesson" + langParam,
          {
            students_ids: formData.studentsId,

            challenges_ids: formData.challengesId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },

  getLessonsIsChallengs({ commit, state, dispatch }, classRoomId) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-classroom-lessons-challenges?classroom_id=" +
            classRoomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getChallenges({ commit, state, dispatch }, lessonId) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/teacher/get-classroom-challanges-by-lesson/" + lessonId + langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  updateStudentName({ commit, state, dispatch }, studentData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "teacher/update-student-name" + langParam,
          {
            student_profile_id: studentData.student_profile_id,
            classroom_id: studentData.classroom_id,
            first_name: studentData.first_name,
            last_name: studentData.last_name,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },

  getStudentCertifications({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/certificates" + "?type=student", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getStudentsDetails({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-school-students-details", {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            course_id: formData.courseId,
          },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  landingInfo({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/landingInfo",
          {
            name: formData.name,
            school_name: formData.school_name,
            email: formData.email,
            phone_number: formData.phone,
            country: formData.country,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          if (error.response) {
            reject(error);
          }
        });
    });
  },
  landingDemo({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/landingDemo",
          {
            name: data.name,
            school_name: data.school_name,
            email: data.email,
            phone_number: data.phone,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          // Error
          console.log(error.config);
        });
    });
  },
  emailRegister({ commit, dispatch }, formData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/register_Parent" + langParam, {
          login_email: formData.email,
          phone_number: formData.phone,
          "g-recaptcha-response": formData.response,
        })
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            if (formData.email != "") {
              messageObj = {
                text: error.response.data.errors.login_email[0],
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data.data.message,
                className: "alert-danger",
                isActive: false,
              };
            }

            reject(messageObj);
          }
        });
    });
  },
  parentRegister({ commit, dispatch }, formData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }

    return new Promise((resolve, reject) => {
      axios
        .post(
          "/parent-set-password/" + formData.token + langParam,
          {
            password: formData.password,
          },
          {
            headers: { Authorization: "Bearer " + formData.token },
          }
        )
        .then((res) => {
          let parentProfile = res.data.data.data.parent_profile || null;
          let userObJ = {
            token: res.data.data.data.api_token,
            username: res.data.data.data.username,
            parentemail: res.data.data.data.parent_email,
            userId: res.data.data.data.id,
            hasVisitedIde: res.data.data.data.has_visited_ide,
            didWatchStory: res.data.data.data.did_watch_storyline_video,
            userType: res.data.data.data.user_type,
          };
          localStorage.setItem("token", res.data.data.data.api_token);

          localStorage.setItem("parentemail", res.data.data.data.parent_email);
          localStorage.setItem("userId", res.data.data.data.id);
          // localStorage.setItem('hasVisitedIde', res.data.data.has_visited_ide);
          // localStorage.setItem('didWatchStory', res.data.data.did_watch_storyline_video);

          if (userObJ.userType == "parent" && parentProfile != null) {
            userObJ.userProfileId = parentProfile.id;
            localStorage.setItem("userProfileId", parentProfile.id);
          }

          commit("authUser", userObJ);
          resolve(true);

          eventBus.showOverlay(false);
          router.push({ name: "manageMyKids", query: { lang: lang } });
        })
        .catch(function(error) {
          eventBus.showOverlay(false);
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.errors.login_email[0],
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
            eventBus.showOverlay(false);
          }
        });
    });
  },
  checkUsername({ commit, dispatch }, username) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }

    return new Promise((resolve, reject) => {
      axios
        .post("/check-username" + langParam, {
          username: username,
        })
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  childRegister({ commit, dispatch }, formData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }

    return new Promise((resolve, reject) => {
      axios
        .post("/register" + langParam, {
          username: formData.username,
          age: formData.age,
          full_name: formData.fullName,
          password: formData.password,
          question_id: formData.question_id,
          answer: formData.answer,
        })
        .then((res) => {
          let studentProfile = res.data.data[0].student_profile || null;

          let userObJ = {
            token: res.data.data[0].api_token,
            username: res.data.data[0].username,
            parentemail: res.data.data[0].parent_email,
            userId: res.data.data[0].id,
            hasVisitedIde: res.data.data[0].has_visited_ide,
            didWatchStory: res.data.data[0].did_watch_storyline_video,
            userType: res.data.data[0].user_type,
            isSchoolStudent: res.data.data[0].is_school_student,
          };

          localStorage.setItem("token", res.data.data[0].api_token);
          localStorage.setItem("username", res.data.data[0].username);
          localStorage.setItem("parentemail", res.data.data[0].parent_email);
          localStorage.setItem("userId", res.data.data[0].id);
          // localStorage.setItem('hasVisitedIde', res.data.data[0].has_visited_ide);
          // localStorage.setItem('didWatchStory', res.data.data[0].did_watch_storyline_video);

          if (userObJ.userType == "student" && studentProfile != null) {
            userObJ.userProfileId = studentProfile.id;
            userObJ.firstName = studentProfile.first_name;
            userObJ.schoolId = studentProfile.school_id;
            localStorage.setItem("userProfileId", studentProfile.id);
          }

          commit("authUser", userObJ);
          resolve(true);
          router.push({ name: "Myworld", query: { lang: lang } });
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.errors.login_email[0],
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  generateChildUsername({ commit, state, dispatch }, name) {
    return new Promise((resolve, reject) => {
      axios
        .get("/generate-student-username" + "?name=" + name)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  schoolDemo({ commit, dispatch }, formData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }

    return new Promise((resolve, reject) => {
      axios
        .post("/school-book-demo" + langParam, {
          school_email: formData.school_email,
          phone_number: formData.phone_number,
          school_name: formData.school_name,
          country: formData.country,
        })
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  resendEmail({ commit, dispatch }, email) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/resend-verify/" + email + langParam, {})
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  resendPhone({ commit, dispatch }, formData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/resend-verify-phone/" +
            formData.phone +
            "?g-recaptcha-response=" +
            formData.response +
            langParam,
          {}
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  socialRegister({ commit, dispatch }, userInfo) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/login-register-social/" + userInfo.loginType + langParam, {
          token: userInfo.ele.auth,
          email: userInfo.ele.user.email,
          name: userInfo.ele.user.name,
          id: userInfo.ele.user.id ? userInfo.ele.user.id : null,
        })
        .then((res) => {
          let parentProfile = res.data.data[0].parent_profile || null;
          let userObJ = {
            token: res.data.data[0].api_token,
            username: res.data.data[0].username,
            parentemail: res.data.data[0].parent_email,
            userId: res.data.data[0].id,
            hasVisitedIde: res.data.data[0].has_visited_ide,
            didWatchStory: res.data.data[0].did_watch_storyline_video,
            userType: res.data.data[0].user_type,
          };
          localStorage.setItem("token", res.data.data[0].api_token);
          localStorage.setItem("parentemail", res.data.data[0].parent_email);
          localStorage.setItem("userId", res.data.data[0].id);
          localStorage.setItem("login-event", "login" + Math.random());
          if (userObJ.userType == "parent" && parentProfile != null) {
            userObJ.userProfileId = parentProfile.id;
            localStorage.setItem("userProfileId", parentProfile.id);
          }

          commit("authUser", userObJ);
          resolve(true);
          router.push({ name: "manageMyKids", query: { lang: lang } });
          eventBus.showOverlay(false);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            eventBus.showOverlay(false);
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  isVerifyNumber({ commit, state, dispatch }, number) {
    let messageObj = {};
    let isVerifyUserUrl = "/parent/verify/";
    return new Promise((resolve, reject) => {
      axios
        .get(isVerifyUserUrl + number)
        .then((res) => {
          resolve(res);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  getCoursesByLevel({ commit, state, dispatch }, track) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/courses-by-level-name?level_name=" + track + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  checkRegisterEmail({ commit, dispatch }, email) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/check-registered-email?email=" + email + langParam, {})
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  checkRegisterPhone({ commit, dispatch }, phone) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/check-registered-phone?phone_number=" + phone + langParam, {})
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },

  getParentKidsInfo({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/get-kids-info", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  checkStudentCourse({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/check-student-course/" +
            formData.studentProfileId +
            "/" +
            formData.courseId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  recoverPhone({ commit, dispatch }, form) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/verify-reset-password-phone/" +
            form.number +
            "/" +
            form.code +
            langParam,
          {}
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  resendRecoverPhone({ commit, dispatch }, formData) {
    let messageObj = {};
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/resend-recover-password-phone/" +
            formData.phone +
            "?g-recaptcha-response=" +
            formData.response +
            langParam,
          {}
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error

          if (error.response) {
            messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  resetPasswordPhone({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post("/reset-password-phone" + langParam, {
          password: formData.password,
          token: formData.token,
          password_confirmation: formData.password_confirmation,
          phone: formData.phone ? formData.phone : "",
        })
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
          }
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            let messageObj = {
              text: error.response.data.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },

  getStudentLesson({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/course-lessons/" +
            formData.id +
            "/" +
            formData.course_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getStudentProject({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/student-projects/" + id + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  // edit Kid info data from parent profile
  editKidInfo({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post("/edit-kid-info/" + formData.kidId, formData, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  createPost({ commit, state, dispatch }, communityData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/create-post",
          {
            student_profile_id: communityData.student_profile_id,
            text: communityData.text,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },

  getPosts({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-posts", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  deletePost({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/delete/" + id,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  updatePost({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/edit-post/" + id,
          {
            //  text: communityData.text,
            //  id:communityData.id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data.posts);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },

  getlastPosts({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/getPostLast", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },

  editChildProfile({ state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post("/update-child-info", formData, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  // new hellocode-v2
  getParentKidsHistory({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/purchases-history" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  safeQuestions({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/safe-questions" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },

  kidrecovery({ commit, state, dispatch }, communityData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/check-security-answer",
          {
            username: communityData.username,
            question_id: communityData.question_id,
            answer: communityData.answer,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  getStudentCourses({ commit, state, dispatch }, id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/student-courses/" + id + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  progressSummary({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/student-collection-details?type=" +
            formData.type +
            "&user_id=" +
            formData.user_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  inviteParent({ commit, state, dispatch }, inviteData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .post(
          "/link-parent-child" + langParam,
          {
            email: inviteData.email,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  getCountry({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/mobile-payment-countries", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  getProvider({ commit, state, dispatch }, country_id) {
    return new Promise((resolve, reject) => {
      axios
        .get("/country-operators/" + country_id, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })

        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  getStudentsPadges({ commit, state, dispatch }, id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/student-badges/" + id + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getStudentTropy({ commit, state, dispatch }, id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/student-trophies/" + id + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentLevels({ commit, state, dispatch }, level_name) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-program-courses?level=" + level_name + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  resetName({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/teacher/change-student-name/" +
            formData.studentProfileId +
            langParam,
          {
            name: formData.name,
            _method: "put",
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            text: error.response.data.errors.name[0],
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },

  mobilePayment({ commit, state, dispatch }, paymentData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/create-mobile-payment",
          {
            amount: paymentData.amount,
            operator_id: paymentData.operator_id,
            phone: paymentData.phone,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.message);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error);
            console.log(error);
          }
        });
    });
  },

  OTP({ commit, state, dispatch }, otpData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "check-otp/" + otpData.pin,
          {
            subscription_plan_id: otpData.subscription_plan_id,
            student_ids: otpData.student_ids,
            with_assisted_learning: otpData.with_assisted_learning,
            coupon_code: otpData.coupon_code,
            course_id: otpData.course_id,
            pin: otpData.pin,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getPriceByCourse({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-price-by-course/" + formData.course_id + "/" + formData.plan_id,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          // dispatch('isAuth',error);
          reject(error);
        });
    });
  },

  getTeacherStudentInfo({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/get-students-info-by-teacher" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  teacherResetPassword({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post("/reset-teacher-password" + langParam, data, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          // dispatch('isAuth', error);
          dispatch("isAuth", error);
          if (error.response.data) {
            resolve(error.response.data);
          }
        });
    });
  },
  getTeacherProfile({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/get-teacher-info" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  editTeacherProfile({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post("/edit-teacher-info" + langParam, formData, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let messageObj = {
            text: res.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj;
          if (error.response) {
            if (error.response.data) {
              messageObj = {
                text: error.response.data,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },
  addTime({ commit, state, dispatch }, { formdata, classRoomId }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      let messageObj = {};
      axios
        .post(
          "/set-classroom-schedules/" + classRoomId + langParam,
          {
            classroom_schedules: formdata.scheduelData,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          if (error.response) {
            messageObj = {
              text: error.response.data.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  resetUserName({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/update-student-username-by-teacher/" +
            formData.classroom_id +
            "/" +
            formData.studentProfileId,
          {
            username: formData.username,
            // _method:'post'
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          // console.log(error.response.data.data.errors.username[0])

          let messageObj = {
            text: error.response.data.data.errors.username[0],
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },
  getStudentEmoji({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-emojis", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  setEmojiAsProfile({ commit, state, dispatch }, id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/set-emoji-as-profile-picture/" + id + langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )

        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);

          let messageObj = {
            text: error.response.data.data.errors.username[0],
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },

  getTeacherInfoBySchooladmin({ commit, state, dispatch }, teacher_id) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/get-teacher-info-by-schooladmin" + "/" + teacher_id + langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getTeacherFromSearch({ commit, state, dispatch }, teacher_name) {
    return new Promise((resolve, reject) => {
      axios
        .get("/search-teacher" + "?teacher_name=" + teacher_name, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getTeacherClassroomBySchoolAdmin({ commit, state, dispatch }, teacher_id) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/get-teacher-classrooms-by-schooladmin" +
            "/" +
            teacher_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getTeacherClassroomInfBySchoolAdmin({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get(
          "/get-classroom-details-by-schooladmin" +
            "/" +
            formData.teacher_id +
            "/" +
            formData.classroom_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getOverallPoint({ commit, state, dispatch }, { school_id }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/school" + "/" + school_id + "/" + "top", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
          console.log(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response.data) {
            resolve(error.response.data);
          }
        });
    });
  },

  getTopStudents({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/get-top-students-by-schooladmin", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response.data) {
            resolve(error.response.data);
          }
        });
    });
  },

  editschoolProfile({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post("/edit-schooladmin-info" + langParam, formData, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let messageObj = {
            text: res.data,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj;
          if (error.response) {
            if (error.response.data) {
              messageObj = {
                text: error.response.data,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },
  getTeachersBySchoolAdmin({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "&lang=" + lang;
      }
      axios
        .get("/get-teachers-by-schooladmin", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  deleteTeacherWithoutStudents({ commit, state, dispatch }, id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/delete-teacher-without-students/" + id + langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolProfile({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-schooladmin-info" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  // getClassroomSearch({ commit, state, dispatch}, classroom_name,page_number ){
  //     return new Promise((resolve, reject) => {

  //         axios.get('/search-classroom'+'/'+'?classroom_name='+ classroom_name+'&page_number='+page_number ,{
  //             headers: { 'Authorization': 'Bearer ' + state.token },

  //         })
  //             .then(response => {
  //                 resolve(response);
  //                 console.log(response)
  //             })
  //             .catch(error => {
  //                 dispatch('isAuth', error);
  //                 reject(error)
  //             })
  //     });
  // },

  getClassroomSearch({ commit, state, dispatch }, classroom_name, page_number) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/search-classroom" +
            "?classroom_name=" +
            classroom_name +
            "&page_number=" +
            1 +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            params: {},
          }
        )
        .then((res) => {
          resolve(res.data);
          // console.log(res)
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  ClasseraLogin({ commit, state, dispatch }, authData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/sso/" + authData.token + langParam)
        .then((res) => {
          let studentProfile = res.data.student_profile || null;
          let schoolProfile = res.data.schooladmin_profile || null;
          let teacherProfile = res.data.teacher_profile || null;
          let userObJ = {
            token: res.data.api_token,
            username: res.data.username,
            img_uri: res.data.img_uri,
            parentemail: res.data.parent_email,
            userId: res.data.id,
            hasVisitedIde: res.data.has_visited_ide,
            didWatchStory: res.data.did_watch_storyline_video,
            userType: res.data.user_type,
            isSchoolStudent: res.data.is_school_student,
          };

          localStorage.setItem("token", res.data.api_token);
          localStorage.setItem("username", res.data.username);
          localStorage.setItem("parentemail", res.data.parent_email);
          localStorage.setItem("userId", res.data.id);
          // localStorage.setItem('login-event', true);
          localStorage.setItem("login-event", "login" + Math.random());
          // localStorage.setItem('hasVisitedIde', res.data.data[0].has_visited_ide);
          // localStorage.setItem('didWatchStory', res.data.data[0].did_watch_storyline_video);

          if (userObJ.userType == "student" && studentProfile != null) {
            userObJ.userProfileId = studentProfile.id;
            userObJ.firstName = studentProfile.first_name;
            userObJ.schoolId = studentProfile.school_id;
            localStorage.setItem("userProfileId", studentProfile.id);
          } else if (userObJ.userType == "schooladmin") {
            userObJ.userProfileId = schoolProfile.school_id;
            userObJ.firstName = schoolProfile.first_name;
            localStorage.setItem("userProfileId", schoolProfile.school_id);
          } else {
            userObJ.userProfileId = teacherProfile.id;
            userObJ.schoolId = teacherProfile.school_id;
            userObJ.firstName = teacherProfile.first_name;
            localStorage.setItem("userProfileId", userObJ.userProfileId);
          }

          commit("authUser", userObJ);
          resolve(true);
          // if (userObJ.userType == 'student' && studentProfile.did_watch_storyline_video == 0) {
          //     router.push({name:'story',query:{lang:lang}})
          // }
          // if (userObJ.userType == 'student' && studentProfile.did_watch_storyline_video == 1) {
          if (userObJ.userType == "student") {
            router.push({ name: "Myworld", query: { lang: lang } });
          } else if (userObJ.userType == "schooladmin") {
            router.push({ name: "teachers", query: { lang: lang } });
          } else if (userObJ.userType == "teacher") {
            router.push({ name: "classrooms", query: { lang: lang } });
          } else {
            router.push({ name: "manageMyKids", query: { lang: lang } });
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            console.log(error, "error");
            let messageObj = {
              text: error.response.data.data || error.username,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
            commit("setMessage", messageObj);
          }
          //console.log(error.config);
        });
    });
  },
  schooladminResetPassword({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post("/reset-schooladmin-password" + langParam, data, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          // dispatch('isAuth', error);
          dispatch("isAuth", error);
          if (error.response.data) {
            resolve(error.response.data);
          }
        });
    });
  },
  generateStudent({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/import-excel-by-teacher/" + data.id + langParam,
          data.formData,
          {
            headers: {
              Authorization: "Bearer " + state.token,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            text: error.response.data.errors[0],
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },
  exportStudentsReportByTeacher({ commit, state, dispatch }, classRoomId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/export-students-report-by-teacher/" + classRoomId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  exportSingleStudentsReportByTeacher({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/export-student-details-excel/" +
            formData.classroom_id +
            "/" +
            formData.student_profile_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            responseType: "blob",
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  exportStudentSkillsExcel({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/export-student-skills-excel/" +
            formData.classroom_id +
            "/" +
            formData.student_profile_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            responseType: "blob",
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  generateStudentProjectsReport({ commit, state, dispatch }, obj) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/generate-student-projects-report/" +
            obj.profileId +
            "/" +
            obj.courseId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  generateStudentOverView({ commit, state, dispatch }, obj) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/generate-student-overview-report/" +
            obj.profileId +
            "/" +
            obj.courseId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            responseType: "blob",
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getPdfData({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/get-student-reports/" +
            formData.profileId +
            "/" +
            formData.courseId +
            "/" +
            formData.type +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
          // console.log(res.data)
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  generateStatisticReport({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/generate-statistic-report-by-schooladmin" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStatisticReport({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-school-statistic-report" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  generateExcelData({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/export-students-report-by-schooladmin/" +
            formData.teacherId +
            "/" +
            formData.classroomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            responseType: "blob",

            params: {
              from: formData.from,
              to: formData.to,
            },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response) {
            let messageObj = {
              text: error.response.data.data.errors.to[0],
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  getTopStudentsClassroom({ commit, state, dispatch }, classRoomId) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get(
          "/get-top-students-with-classroom-by-teacher/" +
            classRoomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response.data) {
            resolve(error.response.data);
          }
        });
    });
  },

  resetTeachersPasswordByAdmin({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/school/reset-school-teacher-password" + langParam,
          {
            teacher_profile_id: formData.teacher_profile_id,
            password: formData.password,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            text: error.response.data.data.errors,
            className: "alert-danger",
            isActive: false,
          };
          reject(messageObj);
        });
    });
  },
  studentsCoursesCompleation({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-student-courses-completions" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
          // console.log(res.data.data.is_junior_student)
          // commit('setStudentType',res.data.data.is_junior_student);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  allStudentExams({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/student-exam" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  examinationSubmission({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    let messageObj = {};
    return new Promise((resolve, reject) => {
      axios
        .post(
          "student-submit-exam" + "?exam_id=" + formData.examId + langParam,
          {
            first_name: formData.first_name,
            middle_name: formData.middle_name,
            last_name: formData.last_name,
            city: formData.city,
            date_of_birth: formData.date_of_birth,
            language: formData.language,
            phone_number: formData.phone_number,
            parent_email: formData.parent_email,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            if (error.response.data.errors) {
              messageObj = {
                text: error.response.data.errors.date_of_birth,
                className: "alert-danger",
                isActive: false,
              };
            } else {
              messageObj = {
                text: error.response.data.data.message,
                className: "alert-danger",
                isActive: false,
              };
            }
            reject(messageObj);
          }
        });
    });
  },
  getExamInfo({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/get-student-exam-info" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  changeClassroomForTeacher({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/change-classroom-teacher/" +
            formData.classRoomId +
            "/" +
            formData.teacher_id +
            langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )

        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
            commit("setMessage", messageObj);
          }
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  changestudentsclassroom({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      let messageObj = {};
      if (!state.token) {
        return;
      }
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/change-students-classroom" + langParam,
          {
            old_classroom_id: formData.old_classroom_id,
            new_classroom_id: formData.new_classroom_id,
            students: formData.students,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          messageObj = {
            text: res.data.data.message,
            className: "alert-success",
            isActive: true,
          };
          resolve(messageObj);
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.message,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  createPostType({ commit, state, dispatch }, post) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/community/posts" + langParam,
          {
            type: post.postType,
            text: post.postText,
            celebration_type: post.celebration_type,
            celebration_id: post.celebration_id,
            submission_id: post.submission_id,
            submission_type_id: post.submission_type_id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
          console.log(res);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            console.log(error.response);
            reject(error.response);
          }
        });
    });
  },
  getStudentAchievements({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "community/users/" + formData.studentId + "/achievements" + langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            params: {
              type: formData.celebration_type,
            },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentHomeContributions({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }

    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/community/posts" +
            "?search=" +
            formData.text +
            "&page=" +
            formData.page +
            "&filter=" +
            formData.filter +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentCoursrs({ commit, state, dispatch }, studentProfileId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/students/" + studentProfileId + "/courses" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  likingAPost({ commit, state, dispatch }, post_id) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "community/posts/" + post_id + "/like",
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  updateStudentPost({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(
          "/community/posts/" + formData.post_id,
          {
            text: formData.text,
          },
          { headers: { Authorization: "Bearer " + state.token } }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  gitTopContributors({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/users/top" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getActivity({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/community/users/" +
            formData.user_id +
            "/posts" +
            "?page=" +
            formData.page +
            "&type=" +
            formData.type +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getProfileDetails({ commit, state, dispatch }, user_id) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/users/" + user_id + "/details" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getFriends({ commit, state, dispatch }, page) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/friends" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            page: page,
          },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  deleteCommunityPost({ commit, state, dispatch }, post_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/community/posts/" + post_id, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  PeopleyouMayKnow({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/users/people-you-may-know" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  Requestfriend({ commit, state, dispatch }, formData) {
    let messageObj = {};

    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/community/friends" + langParam,
          {
            receiver_user_id: formData.receiveruserid,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
          }
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },

  createComment({ commit, state, dispatch }, formData) {
    let messageObj = {};

    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "/community/comments" + langParam,
          {
            post_id: formData.post_id,
            text: formData.text,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
          }
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  likeComment({ commit, state, dispatch }, comment_id) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "community/comments/" + comment_id + "/like",
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  updateStudentComment({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(
          "community/comments/" + formData.comments_id,
          {
            text: formData.text,
          },
          { headers: { Authorization: "Bearer " + state.token } }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  deleteStudentComment({ commit, state, dispatch }, comment_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete("community/comments/" + comment_id, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  correctAnswer({ commit, state, dispatch }, comment_id) {
    let messageObj = {};

    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "community/comments/" +
            comment_id +
            "/make-correct-answer" +
            langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(function(error) {
          if (error.response) {
            messageObj = {
              text: error.response.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  Notificationsfriend({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/users/notifications" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  friendRequests({ commit, state, dispatch }, { obj, page }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/friends/received?status=" + obj.status + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            page: page,
          },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSendrequest({ commit, state, dispatch }, page) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/friends/sent", {
          headers: { Authorization: "Bearer " + state.token },
          params: {
            page: page,
          },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  Accept_requestfriend({ commit, state, dispatch }, sender_user_id) {
    let messageObj = {};

    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      // const sender_user_id=req.query.sender_user_id
      axios
        .patch(
          "/community/friends/" + sender_user_id + "/accept" + langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
          }
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },
  decline_requestfriend({ commit, state, dispatch }, sender_user_id) {
    let messageObj = {};

    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      // const sender_user_id=req.query.sender_user_id
      axios
        .patch(
          "/community/friends/" + sender_user_id + "/decline" + langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          if (res) {
            let messageObj = {
              text: res.data.data.message,
              className: "alert-success",
              isActive: false,
            };
            resolve(messageObj);
          }
        })
        .catch(function(error) {
          // Error
          if (error.response) {
            messageObj = {
              text: error.response.data.errors,
              className: "alert-danger",
              isActive: false,
            };
            reject(messageObj);
          }
        });
    });
  },

  deleteFriend({ commit, state, dispatch }, friend_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/community/friends/" + friend_id, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  getPostTree({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    let tabsConditions;
    let page;
    let correctAnswerReturn;
    if (formData.tabsCondition && formData.correctAnswerReturn == false) {
      tabsConditions = "?orderBy=" + formData.tabsCondition;
      page = "&page=" + formData.page;
      correctAnswerReturn = "";
    } else if (formData.tabsCondition && formData.correctAnswerReturn == true) {
      tabsConditions = "?orderBy=" + formData.tabsCondition;
      correctAnswerReturn = "&unlimited=" + formData.correctAnswerReturn;
      page = "&page=" + formData.page;
    } else if (
      formData.tabsCondition == "" &&
      formData.correctAnswerReturn == false
    ) {
      correctAnswerReturn = "";
      page = "?page=" + formData.page;
      tabsConditions = "";
    } else if (
      formData.tabsCondition == "" &&
      formData.correctAnswerReturn == true
    ) {
      correctAnswerReturn = "?unlimited=" + formData.correctAnswerReturn;
      page = "&page=" + formData.page;
      tabsConditions = "";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/community/posts/" +
            formData.postid +
            tabsConditions +
            correctAnswerReturn +
            page +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  hiddenPosts({ commit, state, dispatch }) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/posts/hidden" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  unhidePost({ commit, state, dispatch }, post_id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/community/posts/" + post_id + "/restore" + langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  getAchievements({ commit, state, dispatch }, user_id) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/users/" + user_id + "/achievements" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getPostLikesContributors({ commit, state, dispatch }, post_id) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/community/posts/" + post_id + "/like", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  searchfriends({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("community/users" + "?search=" + formData.text, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  Clearnotfication({ commit, state, dispatch }, formData) {
    let messageObj = {};

    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .post(
          "community/users/notifications" + langParam,
          {
            ids: formData.id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          //  console.log(res)

          resolve(res);
        })
        .catch(function(error) {
          // Error

          reject(error);
        });
    });
  },

  deleterequestfriend({ commit, state, dispatch }, friend_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/community/friends/" + friend_id, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch(function(error) {
          dispatch("isAuth", error);
          if (error.response) {
            reject(error.response);
          }
        });
    });
  },
  coursesCanBePurchased({ commit, state, dispatch }, studentProfileId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/courses-can-be-purchased/" + studentProfileId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  // Memory Game
  MemoryGame({ commit, state, dispatch }, Stage) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/games/stage/" + Stage + "/start",
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getGameLessonsAndStages({ commit, state, dispatch }, lessonId) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/games" + "?lesson_id=" + lessonId, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getMemoryGameFlipCard({ commit, state, dispatch }, formData) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/games/memory/stage/" + formData.stage + "/" + formData.index, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  MemoryGame({ commit, state, dispatch }, Stage) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/games/stage/" + Stage + "/start",
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  MemoryGameMatchCards({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/games/memory/stage/" + formData.Stage + "/match",
          {
            values: [formData.card1, formData.card2],
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getdraganddrop({ commit, state, dispatch }, stageId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/games/stage/" + stageId + "/start" + langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          console.log(error);
          dispatch("isAuth", error);
        });
    });
  },
  getpuzzle({ commit, state, dispatch }, stageId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/games/stage/" + stageId + "/start" + langParam,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          console.log(error);
          dispatch("isAuth", error);
        });
    });
  },
  matchinganswer({ commit, state, dispatch }, { formData, stageId }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          "games/connect/stage/" + stageId + "/" + "match" + langParam,
          {
            keyword_id: formData.keyword_id,
            card_id: formData.card_id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          console.log(error);
          dispatch("isAuth", error);
        });
    });
  },

  gamesstages({ commit, state, dispatch }, lesson_id) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/games" + "?lesson_id=" + lesson_id + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  flipAllMemoryGame({ commit, state, dispatch }, stage_id) {
    return new Promise((resolve, reject) => {
      // api/games/memory/stage/1/all'
      axios
        .get("/games/memory/stage/" + stage_id + "/all", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  ShareReportExcel({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/export-student-details-excel/" +
            formData.classroom_id +
            "/" +
            formData.student_profile_id +
            "/share?parent_email=" +
            formData.email +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    }).catch((error) => {
      dispatch("isAuth", error);
      reject(error);
    });
  },
  ShareStudentOverview({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/generate-student-overview-report/" +
            formData.student_profile_id +
            "/" +
            formData.courseId +
            "/share?parent_email=" +
            formData.email +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            responseType: "blob",
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  ShareStudentProject({ commit, state, dispatch }, formData) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/generate-student-projects-report/" +
            formData.student_profile_id +
            "/" +
            formData.courseId +
            "/share?parent_email=" +
            formData.email +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getResources({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/course-resources" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getLessonPlan({ commit, state, dispatch }, courseId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/lesson-plans/" + courseId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolTeacherClassroomStudentSubmissionsexport(
    { commit, state, dispatch },
    obj
  ) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-teacher-classroom-student-submissions/" +
            obj.teacherId +
            "/export" +
            "?classroom_id=" +
            obj.classroomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getExtraRescource({ commit, state, dispatch }, courseId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/course-resources/" + courseId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getSchoolTeacherClassroomLessonSubmissionsexport(
    { commit, state, dispatch },
    obj
  ) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios(
        "/teacher/get-school-teacher-classroom-lesson-submissions/" +
          obj.teacherId +
          "/export" +
          "?classroom_id=" +
          obj.classroomId +
          langParam,
        {
          headers: { Authorization: "Bearer " + state.token },
          method: "GET",
          responseType: "blob",
        }
      )
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolTeacherClassroomChallengeSubmissionsexport(
    { commit, state, dispatch },
    obj
  ) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios(
        "/teacher/get-school-teacher-classroom-course-submissions/" +
          obj.teacherId +
          "/export" +
          "?classroom_id=" +
          obj.classroomId +
          langParam,
        {
          headers: { Authorization: "Bearer " + state.token },
          method: "GET",
          responseType: "blob",
        }
      )
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolTeacherClassroomAssessmentsExport({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/teacher/get-school-teacher-classroom-assessments/" +
            obj.teacherId +
            "/export" +
            "?classroom_id=" +
            obj.classroomId +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            method: "GET",
            responseType: "blob",
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getSchoolTeacherClassroomAssessmentsExport({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios(
        "/teacher/get-school-teacher-classroom-assessments/" +
          obj.teacherId +
          "/export" +
          "?classroom_id=" +
          obj.classroomId +
          "?&lesson_id=" +
          obj.lesson_id +
          langParam,
        {
          headers: { Authorization: "Bearer " + state.token },
          method: "GET",
          responseType: "blob",
        }
      )
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  exportSingleStudentsSkillsReportByTeacher(
    { commit, state, dispatch },
    formData
  ) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/export-student-skills-excel/" +
            formData.classroom_id +
            "/" +
            formData.student_profile_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            responseType: "blob",
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getallquestionbank({ commit, state, dispatch }, courseId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/question-bank/" + courseId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  studentJuniorSubmission({ commit, state, dispatch }, formdata) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/submit-challenge-lesson",
          {
            lesson_id: formdata.lessonId,
            course_id: formdata.courseId,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          dispatch("isAuth", error);
        });
    });
  },

  getStudentComplete({ commit, state, dispatch }, classroomId) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/classrooms/" + classroomId + "/complete" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getCertficatecompletion({ commit, state, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/certificates/students/" + formData.student_profile_id,
          {
            type: formData.type,
            course_id: formData.course_id,
          },
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          dispatch("isAuth", error);
        });
    });
  },
  generalReportschool({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/general-school-report" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          method: "GET",
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  generateCompletionCerficatestudent(
    { commit, state, dispatch },
    certficate_id
  ) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/certificates/" + certficate_id + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          method: "GET",
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getCompletionCerficatestudent(
    { commit, state, dispatch },
    student_profile_id
  ) {
    if (!state.token) {
      return;
    }
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/certificates/teachers/students?student_profile_id=" +
            student_profile_id +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getStudentCertficate({ commit, state, dispatch }, student_type) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/certificates?type=" + student_type + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  generateCerficateOfAppreciationTeacher(
    { commit, state, dispatch },
    teacher_id
  ) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/certificates/teachers/" + teacher_id,
          {},
          {
            headers: { Authorization: "Bearer " + state.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getTeacherCertficate({ commit, state, dispatch }, certificate_uri) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "&lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${certificate_uri.replaceAll("{{hc}}/api", "")}?type=teacher` +
            langParam,
          {
            headers: { Authorization: "Bearer " + state.token },
            method: "GET",
            responseType: "blob",
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  getTeacherSideCertificate({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/certificates/teachers", {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  generalReportschoolview({ commit, state, dispatch }) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/general-school-report/view" + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          method: "GET",
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  getSchooladmin({ commit, state, dispatch }, search) {
    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    let filter;
    if (search) {
      filter = "?search=" + search;
      langParam = "&lang=" + lang;
    } else {
      filter = "";
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/school/schools" + filter + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },
  generateSchoolsReports({ commit, state, dispatch }, status) {
    let schoolStatus;
    if (status == "all") {
      schoolStatus = "/all";
    } else {
      schoolStatus = "?school_id=" + status;
    }

    let lang = router.currentRoute.query.lang;
    let langParam = "";
    if (lang) {
      langParam = "?lang=" + lang;
    }
    return new Promise((resolve, reject) => {
      axios
        .get("/general-school-report" + schoolStatus + langParam, {
          headers: { Authorization: "Bearer " + state.token },
          method: "GET",
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error);
        });
    });
  },

  LockedCommunity({ commit, state, dispatch }, classRoomId) {
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/teacher/lock-unlock-community/" + classRoomId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          let messageObj = {
            // text: error.response.data.data.errors,
            text: error.response.data.errors,
            className: "alert-danger",
            isActive: false,
          };
          console.log(messageObj);
          reject(messageObj);
        });
    });
  },

  // CheckCommunity({ commit, state, dispatch },) {
  //     return new Promise((resolve, reject) => {
  //         let lang = router.currentRoute.query.lang;
  //         let langParam = '';
  //         if (lang) {
  //             langParam = '?lang=' + lang;
  //         }
  //         axios.get('check-community' + langParam, {
  //             headers: { 'Authorization': 'Bearer ' + state.token },

  //         })
  //             .then(res => {
  //                 resolve(res);
  //             })
  //             .catch(error => {
  //                 dispatch('isAuth', error);
  //                 reject(error)
  //             })
  //     });
  // },

  getChallengeProject({ commit, state, dispatch }, obj) {
    if (!state.token) {
      return;
    }
    return new Promise((resolve, reject) => {
      let lang = router.currentRoute.query.lang;
      let langParam = "";
      if (lang) {
        langParam = "?lang=" + lang;
      }
      axios
        .get("/challenge-goal/" + obj.challengeId + langParam, {
          headers: { Authorization: "Bearer " + state.token },
        })
        .then((res) => {
          let data = res.data.data;

          resolve(data);
        })
        .catch((error) => {
          dispatch("isAuth", error);
          reject(error.response);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js